import type { FunctionComponent } from "react";
import { Route, Routes } from "react-router-dom";
import Gruveo from "./pages/gruveo";
import WebRTC from "./pages/web-rtc";
import NexToMeet from "./pages/nextomeet";
import CrowdView from "./pages/crowdview";
import * as Sentry from "@sentry/react";
import "./App.css";

const App: FunctionComponent = () => (
  <div className="App">
    <Routes>
      <Route element={<Gruveo />} path="/gruveo/:roomName" />
      <Route element={<WebRTC />} path="/web-rtc/:roomName" />
      <Route element={<CrowdView />} path="/multibox/:alias" />
      <Route element={<NexToMeet />} path="/nextomeet/:uid" />
    </Routes>
  </div>
);

export default Sentry.withProfiler(App);
